import React from 'react';

const ShareDropdown = () => (
  <ul className="block w-full bg-white shadow">
    <li>
      <a href="#" className="block p-3">Copy Details</a>
    </li>
    <li>
      <a href="#" className="block p-3">Email Details</a>
    </li>
  </ul>
);

export default ShareDropdown;
